import { render, staticRenderFns } from "./TermDocument.vue?vue&type=template&id=dbf0e746&scoped=true"
import script from "./TermDocument.vue?vue&type=script&lang=js"
export * from "./TermDocument.vue?vue&type=script&lang=js"
import style0 from "./TermDocument.vue?vue&type=style&index=0&id=dbf0e746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf0e746",
  null
  
)

export default component.exports